<template>
    <div class="row">
        <div class="col-sm-12 col-md-9 col-lg-6">
            <div class="container text-center">
                <div class="contenedor">
                    <div class="col-md-10 col-lg-8 offset-md-1 offset-lg-2">
                        <h2>Comité de Crédito Digital</h2>
                        <h5>Escribe tu nueva contraseña</h5>
                        <form class="mt-3" @submit.prevent="validar">
                            <div class="form-floating mt-5 mb-5">
                                <input type="password" class="form-control" id="floatingPassword1" placeholder="Contraseña" required v-model="password">
                                <label for="floatingCorreo">Contraseña</label>
                            </div>
                            <div class="form-floating mt-5 mb-5">
                                <input type="password" class="form-control" id="floatingPassword2" placeholder="Confirmar Contraseña" required v-model="confirmPassword">
                                <label for="floatingCorreo">Confirmar Contraseña</label>
                            </div>
                            <p class="error" v-if="error">
                                Las contraseñas no coinciden
                            </p>
                            <div class="d-flex mt-3 mb-5">
                                <router-link to="/" class="ms-auto">Regresar</router-link>
                            </div>
                            <div class="row">
                                <button type="submit" class="btn btn-primary rounded-pill col-sm-8 col-md-6 offset-sm-2 offset-md-3">Aceptar</button>
                            </div>
                        </form>
                    </div>
                    <div class="col-md-12 offset-md-2">
                        <footer class="col-md-8">
                            <p>
                                Términos y Condiciones son aplicables al uso de los servicios
                                ofrecidos por Autofinanciamiento Nacional, S.A. de C.V. y
                                Bienes Programados, S.A. de CV.
                            </p>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
        <div id="loginImage" class="col-auto col-sm-0 col-md-3 col-lg-6  offset-md-3 offset-lg-6 h-100 position-fixed"></div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'CambioContrasenia',

    data() {
        return {
            respuesta: {},
            usuarioToken: {},
            usuario: '',
            token: '',
            colaboradorId: '',
            password: '',
            confirmPassword: '',
            error: false
        }
    },

    mounted() {
        this.token =this.$route.query.token
        this.colaboradorId=this.$route.query.colaboradorId
        if (this.token == undefined || this.token == null) {
            this.$router.push("/")
        }
    },

    methods: {
        validar() {
            if (this.password != this.confirmPassword) {
                this.error = true
            }
            if (this.password == this.confirmPassword) {
                this.error = false
                this.cambiarPassword()
            }
        },

        async cambiarPassword() {
            var usuarioRecuperacion = {
                ColaboradorId: this.colaboradorId,  
                Contrasenia: this.password,
                ConfirmarContrasenia: this.confirmPassword,
                Token: this.token,
            }
            await this.axios
                .post("Usuario/CambiarContrasenia", usuarioRecuperacion)
                .then((response) => {
                    this.respuesta = response.data;
                    if (this.respuesta.estatusRespuesta == this.estatusRespuesta.OK) {
                        const callback = function(){ this.$router.push("/")};
                        this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: 'La contraseña se cambió con éxito.', Callback: callback });
                    }
                    else {this.notificar({Estatus: this.respuesta.estatusRespuesta, Mensaje: this.respuesta.mensaje})}
                })
                .catch((error) => {
                    this.notificar({Estatus: this.estatusRespuesta.ERROR, Mensaje: error});
                }
            )
        }
    }
})
</script>

<style scoped>
    #loginImage {
        /*background: linear-gradient(223.15deg, #242348 12.21%, #5A55AA 83.68%);*/
        background-image: url('../../public/img/login.jpg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 50%;
        height: 100%;
    }

    h2 {
        margin-top: 25%;
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 35px;
        line-height: 43px;
        color: #151965;
        font-weight: 700;
    }

    h5 {
        margin-top: 20px;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 24px;
        color: #302D74;
        opacity: 0.5;
    }

    label {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 15px;
        line-height: 18px;
        color: #151965;
    }

    button {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 22px;
        color: #FFFFFF;
        height: 40px;
    }

    #floatingCorreo {
        border: 0;
        border-bottom: solid 2px #E9E9F0;
    }

    footer {
        font-size: 12px;
        font-weight: 400;
        color: #43425d;
        margin: 15px 0px;
    }

    .contenedor {
        height: 100vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: 100vh;
    }
    /*
    .formLogin {
        margin-top: 65px;
    }

    #contrasena {
        margin-top: 46px;
    }

    .espacio {
        margin-top: 65px;
    }
    */
    .error {
        color: rgb(211, 0, 0);
    }

    @media (max-width: 992px) {
        #loginImage {
            display: none;
        }
    }
</style>